<iframe #demosite height='100%' width='100%' [src]='safeUrl'></iframe>
<chatstyleai-chatbox *ngIf='demo' id="chatbox"
  [channel]='demo.tag' version=''
  options='{"isOpen":"false", "loadHistory":"true", "autoStart":"true"}'></chatstyleai-chatbox>
